/**
 * @type { import("vue/types/options").ThisTypedComponentOptionsWithRecordProps<import('vue'), { isVideoPaused: boolean; isVideoPlaying: boolean }, { playVideo(): void, puaseVideo }, {}, {}> }
 */
export const VideoMixin = {
  data() {
    return {
      isVideoPaused: false,
      isVideoPlaying: false,
      videoListeners: {
        pause: this.videoPauseHandler,
        play: this.videoPlayHandler
      }
    }
  },
  methods: {
    videoPauseHandler() {
      this.isVideoPaused = true
      this.isVideoPlaying = false
    },
    videoPlayHandler() {
      this.isVideoPaused = false
      this.isVideoPlaying = true
    }
  }
}
